import { useTranslation } from "react-i18next";
import { HTMLAttributes } from "react";

import { Account, Location } from "@/api/opb/opbTypes";

interface IncorrectBankInfoBannerProps extends HTMLAttributes<HTMLDivElement> {
  account: Account;
  location?: Location;
  isActivated: boolean;
}

export function AccountActivationBanner({
  account,
  className = "",
  location,
  isActivated,
  ...props
}: IncorrectBankInfoBannerProps) {
  const { t } = useTranslation("dashboard");

  const name = location
    ? `${location.city} — ${location.name}`
    : account.globalAccountName;

  return (
    <div
      className={`rounded-lg py-3 px-5 ${
        isActivated ? "bg-ocean-99" : "bg-honey-99"
      } text-sm shadow-card ${className}`}
      {...props}
    >
      <div className="font-bold" data-testid="incorrect_bank_info_banner-title">
        {name}
      </div>
      {isActivated && (
        <div className="font-bold pt-2">{t("Your membership is active")}</div>
      )}
      <div className="flex mt-2 items-center sm:flex-row flex-col">
        <div className="mr-4">
          {isActivated
            ? t("Teammates activation emails")
            : t("Please pay your first invoice to activate your membership.")}
        </div>
      </div>
    </div>
  );
}
